<div class="space-y-6">

    <app-page-breadcrumb pageTitle="Mi Perfil" />

    <!-- Avatar + info -->
    <div class="flex items-center gap-5 bg-white dark:bg-white/[0.03] rounded-2xl border border-gray-200 dark:border-gray-800 p-6">
        <div class="w-16 h-16 rounded-full bg-brand-500 flex items-center justify-center text-xl font-bold text-white shrink-0 select-none">
            {{ userInitials }}
        </div>
        <div>
            <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ firstName }} {{ lastName }}</p>
            <p class="text-sm text-gray-500 dark:text-gray-400 font-mono">&#64;{{ username }}</p>
            <p class="text-xs text-gray-400 mt-1">{{ documentType }} · {{ documentNumber }} · Perfil: {{ profile }}</p>
        </div>
    </div>

    <!-- Datos personales -->
    <div class="bg-white dark:bg-white/[0.03] rounded-2xl border border-gray-200 dark:border-gray-800 p-6">
        <div class="flex items-center justify-between mb-5">
            <div>
                <h2 class="text-base font-semibold text-gray-800 dark:text-white">Datos personales</h2>
                <p class="text-xs text-gray-400 mt-0.5">Actualiza tu nombre y usuario de acceso.</p>
            </div>
            <button type="button" (click)="saveProfile()" [disabled]="savingProfile"
                class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 transition-colors">
                @if (savingProfile) {
                <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
                Guardando…
                } @else {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                Guardar
                }
            </button>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
                <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nombres</label>
                <input type="text" [(ngModel)]="firstName" placeholder="Ej: Juan"
                    class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500" />
            </div>
            <div>
                <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Apellidos</label>
                <input type="text" [(ngModel)]="lastName" placeholder="Ej: Pérez"
                    class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500" />
            </div>
            <div class="sm:col-span-2">
                <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Usuario *</label>
                <input type="text" [ngModel]="username" disabled
                    class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 cursor-not-allowed opacity-60" />
            </div>
        </div>
    </div>

    <!-- Cambio de contraseña -->
    <div class="bg-white dark:bg-white/[0.03] rounded-2xl border border-gray-200 dark:border-gray-800 p-6">
        <div class="flex items-center justify-between mb-5">
            <div>
                <h2 class="text-base font-semibold text-gray-800 dark:text-white">Cambiar contraseña</h2>
                <p class="text-xs text-gray-400 mt-0.5">Usa una contraseña segura de mínimo 6 caracteres.</p>
            </div>
            <div class="flex gap-2">
                <button type="button" (click)="resetPassword()"
                    [disabled]="(!newPassword && !confirmPassword) || savingPassword"
                    class="px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 dark:bg-white/5 dark:text-gray-400 dark:border-gray-700 disabled:opacity-40">
                    Limpiar
                </button>
                <button type="button" (click)="savePassword()" [disabled]="savingPassword"
                    class="px-3 py-1.5 text-xs font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 transition-colors">
                    {{ savingPassword ? 'Guardando…' : 'Actualizar' }}
                </button>
            </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
                <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nueva contraseña</label>
                <div class="relative">
                    <input [type]="showNewPassword ? 'text' : 'password'" [(ngModel)]="newPassword"
                        placeholder="Mínimo 6 caracteres"
                        class="w-full px-3 py-2 pr-10 text-sm rounded-lg border focus:outline-none focus:ring-2 focus:ring-brand-500 bg-white dark:bg-white/5 dark:text-white"
                        [class.border-red-400]="passwordSubmitted && (!newPassword || newPassword.length < 6)"
                        [class.border-gray-300]="!(passwordSubmitted && (!newPassword || newPassword.length < 6))"
                        [class.dark:border-gray-700]="!(passwordSubmitted && (!newPassword || newPassword.length < 6))" />
                    <button type="button" (click)="showNewPassword = !showNewPassword"
                        class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                        @if (showNewPassword) {
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                        } @else {
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        }
                    </button>
                </div>
                @if (passwordSubmitted && !newPassword) {
                <p class="mt-1 text-xs text-red-500">Obligatorio</p>
                } @else if (passwordSubmitted && newPassword && newPassword.length < 6) {
                <p class="mt-1 text-xs text-red-500">Mínimo 6 caracteres</p>
                }
            </div>
            <div>
                <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Confirmar contraseña</label>
                <div class="relative">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="confirmPassword"
                        placeholder="Repite la contraseña"
                        class="w-full px-3 py-2 pr-10 text-sm rounded-lg border focus:outline-none focus:ring-2 focus:ring-brand-500 bg-white dark:bg-white/5 dark:text-white"
                        [class.border-red-400]="passwordSubmitted && newPassword && newPassword !== confirmPassword"
                        [class.border-gray-300]="!(passwordSubmitted && newPassword && newPassword !== confirmPassword)"
                        [class.dark:border-gray-700]="!(passwordSubmitted && newPassword && newPassword !== confirmPassword)" />
                    <button type="button" (click)="showConfirmPassword = !showConfirmPassword"
                        class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                        @if (showConfirmPassword) {
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                        } @else {
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        }
                    </button>
                </div>
                @if (passwordSubmitted && newPassword && newPassword !== confirmPassword) {
                <p class="mt-1 text-xs text-red-500">Las contraseñas no coinciden</p>
                }
            </div>
        </div>
    </div>

</div>
